function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Stack, Text, PrimaryButton, DefaultButton, Spinner, FontIcon, ScreenWidthMinXLarge, mergeStyleSets } from '@fluentui/react';
import Animation from '@shared/components/animation';
import { isNewCustomer, convertStepIdToName, confirmBillingCountry, redirectToAppDetails } from '@shared/utils/checkoutUtils';
import { getWindow } from '@shared/services/window';
import SpzaComponent from '@shared/components/spzaComponent';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import Stepper, { StepId, StepperNodeStatus, StepperColors } from '@appsource/components/stepper';
import { CheckoutSteps, TeamsCheckoutSteps } from '@appsource/components/checkoutSteps';
import { getNpsModule } from '@appsource/utils/nps';
import { logger } from '@src/logger';
import { HiddenComponentWrapper } from '@appsource/components/HiddenComponentWrapper';
import { isBagTransactable } from '@shared/utils/appUtils';
import { PurchaseBlendsCheckoutWithRouter } from '@appsource/components/purchaseBlendsCheckout';
import { getAppContainerProps, getUserType } from '@appsource/utils/checkoutSettings';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { AzureSubscriptionPurchase } from '@appsource/components/AzureSubscriptionPurchase/azureSubscriptionPurchase';
import { isMaccUser } from '@shared/utils/userUtils';
const NEW_CUSTOMER_CHECKOUT_LENGTH = 5;
const OLD_CUSTOMER_CHECKOUT_LENGTH = 4;
const contentStyles = mergeStyleSets({
    azureSubscriptionPurchase: {
        [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
            display: 'none'
        }
    }
});
export class Wizard extends SpzaComponent {
    componentDidMount() {
        var _checkout_items, _this_state_steps_this_props_currentStep;
        const { checkout, users: { roleDefinitions } = {}, adminFlow, isBagOffer, isProfessionalService, source, location: { pathname = '' } = {}, createCheckoutId } = this.props;
        const cartItem = (_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0];
        const userType = getUserType(roleDefinitions);
        const checkoutId = uuidv4();
        createCheckoutId({
            checkoutId: uuidv4()
        });
        const payloadDetails = {
            step: convertStepIdToName((_this_state_steps_this_props_currentStep = this.state.steps[this.props.currentStep]) === null || _this_state_steps_this_props_currentStep === void 0 ? void 0 : _this_state_steps_this_props_currentStep.id),
            entityId: (cartItem === null || cartItem === void 0 ? void 0 : cartItem.entityId) || '',
            appTitle: (cartItem === null || cartItem === void 0 ? void 0 : cartItem.appTitle) || '',
            userType,
            adminFlow,
            isBagOffer,
            isProfessionalService,
            source,
            checkoutId
        };
        const payload = {
            page: pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.Start,
            details: JSON.stringify(payloadDetails)
        };
        this.log(payload);
        this.fetchProductIfNeeded();
    }
    componentDidUpdate() {
        var _this_props_checkout_items__product_plans, _this_props_checkout_items__product, _this_props_checkout_items_, _this_props_checkout_items, _this_props_checkout, _this_props_checkout_items_1, _this_props_checkout_items1, _this_props_checkout1;
        const footer = document.getElementById('footerArea');
        const rootContainer = document.getElementById('spza-root');
        if (footer) {
            footer.classList.add('checkout-hide-footer');
        }
        if (rootContainer) {
            rootContainer.classList.add('fullHeight-vh');
        }
        if (!this.props.wizardLoading && !this.hasUpdatedStepsPostLoading) {
            this.hasUpdatedStepsPostLoading = true;
        }
        if ((((_this_props_checkout = this.props.checkout) === null || _this_props_checkout === void 0 ? void 0 : (_this_props_checkout_items = _this_props_checkout.items) === null || _this_props_checkout_items === void 0 ? void 0 : (_this_props_checkout_items_ = _this_props_checkout_items[0]) === null || _this_props_checkout_items_ === void 0 ? void 0 : (_this_props_checkout_items__product = _this_props_checkout_items_.product) === null || _this_props_checkout_items__product === void 0 ? void 0 : (_this_props_checkout_items__product_plans = _this_props_checkout_items__product.plans) === null || _this_props_checkout_items__product_plans === void 0 ? void 0 : _this_props_checkout_items__product_plans.filter((plan)=>plan.availabilities.length).length) === 0 || !((_this_props_checkout1 = this.props.checkout) === null || _this_props_checkout1 === void 0 ? void 0 : (_this_props_checkout_items1 = _this_props_checkout1.items) === null || _this_props_checkout_items1 === void 0 ? void 0 : (_this_props_checkout_items_1 = _this_props_checkout_items1[0]) === null || _this_props_checkout_items_1 === void 0 ? void 0 : _this_props_checkout_items_1.product) && this.props.productFetched) && this.hasAlreadyRequestedProduct) {
            redirectToAppDetails(Constants.Tabs.PlansAndPrice, this.props.app, this.context.buildHref);
        }
        this.fetchProductIfNeeded();
    }
    componentWillUnmount() {
        var _checkout_items;
        const { users: { roleDefinitions } = {}, adminFlow, isBagOffer, isProfessionalService, checkout, checkoutId, location: location1, createCheckoutId } = this.props;
        const userType = getUserType(roleDefinitions);
        this.resetCheckout();
        const footer = document.getElementById('footerArea');
        const rootContainer = document.getElementById('spza-root');
        if (footer) {
            footer.classList.remove('checkout-hide-footer');
        }
        if (rootContainer) {
            rootContainer.classList.remove('fullHeight-vh');
        }
        const cartItem = (_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0];
        const { bigId = '', entityId = '', skuId = '', appTitle = '', title: planTitle = '' } = cartItem || {};
        if (this.state.steps[this.props.currentStep].id < StepId.ConfigureNow) {
            const payload = {
                page: location1.pathname,
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.Abandon,
                details: JSON.stringify({
                    checkoutId,
                    duration: performance.now() - this.wizardStartTime,
                    userType,
                    adminFlow,
                    isBagOffer,
                    isProfessionalService,
                    step: convertStepIdToName(this.state.steps[this.props.currentStep].id),
                    cartItem: {
                        bigId,
                        entityId,
                        skuId,
                        appTitle,
                        planTitle
                    }
                })
            };
            this.log(payload);
        }
        createCheckoutId({}); // Clear checkoutId for next session
    }
    renderImpl() {
        var _items_, _product_plans;
        const { app, // entityId is updated with the view, while product is only fetched once the view is ready
        app: { entityId }, currentStep, wizardLoading, checkout: { items }, checkout, users: { tenantsDetails: { details: { tenantId } } }, users, adminFlow, isProfessionalService } = this.props;
        const product = items === null || items === void 0 ? void 0 : (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.product;
        const shouldFetchProduct = !(product === null || product === void 0 ? void 0 : (_product_plans = product.plans) === null || _product_plans === void 0 ? void 0 : _product_plans.length) || // Indicates product is undefined
        entityId !== (product === null || product === void 0 ? void 0 : product.legacyId); // indicates the product (app) user is trying to purchase was changes
        const { steps } = this.state;
        const stepperProps = {
            steps,
            currentStep
        };
        const isBagOffer = isBagTransactable(app);
        const stepId = stepperProps.steps[`${currentStep}`].id;
        const isMSuser = tenantId === Constants.MSTenantId;
        const hideFooter = isProfessionalService && stepId === StepId.ConfigureNow;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                wizardLoading && !this.hasUpdatedStepsPostLoading && /*#__PURE__*/ _jsx("div", {
                    className: "checkout-container-root-horizontal",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "loader billing-terms",
                        children: /*#__PURE__*/ _jsx(Animation, {})
                    })
                }),
                !wizardLoading && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "checkout-container-root-horizontal",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: 'flex-row stepperWizardContainer',
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-col stepper-container-class",
                                        children: /*#__PURE__*/ _jsx(Stepper, _object_spread({}, stepperProps))
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: 'wizard-content-step-container',
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: 'flex-col',
                                                children: this.getActiveStepComponent()
                                            }),
                                            !shouldFetchProduct && !isMSuser && !isNewCustomer(checkout) && stepId <= StepId.Payment ? /*#__PURE__*/ _jsx(HiddenComponentWrapper, {
                                                hide: stepId !== StepId.Payment,
                                                children: /*#__PURE__*/ _jsx(PurchaseBlendsCheckoutWithRouter, _object_spread_props(_object_spread({}, this.props), {
                                                    setPi: this.setPi,
                                                    paymentStepStartedTime: this.paymentStepStartedTime,
                                                    context: this.context,
                                                    disableBackButton: this.disableBackButton
                                                }), `PurchaseBlendsComponent${adminFlow ? 'Admin' : 'IW'}`)
                                            }) : stepId === StepId.Payment && /*#__PURE__*/ _jsx("div", {
                                                className: "loadingContainer",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "loading",
                                                    children: /*#__PURE__*/ _jsx(Spinner, {
                                                        label: this.context.loc('Gallery_Loading', 'Loading...'),
                                                        ariaLive: "assertive",
                                                        labelPosition: "left"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !hideFooter && /*#__PURE__*/ _jsxs("div", {
                            className: "checkout-sticky-footer-container",
                            children: [
                                /*#__PURE__*/ _jsx("hr", {
                                    className: "checkoutFooter"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: 'flex-row mb-50 checkout-container-root-horizontal',
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        tokens: {
                                            childrenGap: 10
                                        },
                                        className: "pbNavigationControls",
                                        horizontal: true,
                                        verticalAlign: "center",
                                        children: [
                                            /*#__PURE__*/ _jsx(Stack.Item, {
                                                children: /*#__PURE__*/ _jsx(DefaultButton, {
                                                    text: this.context.loc('Checkout_BackButton', 'Back'),
                                                    "data-bi-id": 'previousBtn',
                                                    "data-bi-name": 'Step back checkout button',
                                                    onClick: this.handleBackClick,
                                                    disabled: this.shouldDisableBackButton(stepId),
                                                    hidden: this.hideBackButton(stepId)
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Stack.Item, {
                                                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                                                    "data-bi-id": 'nextBtn',
                                                    "data-bi-name": 'Next step checkout button',
                                                    className: "next-button-class",
                                                    text: this.getNextButtonDisplayText(stepId),
                                                    hidden: stepId === StepId.Payment,
                                                    onClick: this.getNextButtonLogic(stepId),
                                                    disabled: this.shouldDisableNextButton(stepId)
                                                })
                                            }),
                                            currentStep === StepId.SelectBillingCountry && !isBagOffer && !isProfessionalService && !isMaccUser(users) && /*#__PURE__*/ _jsxs(Stack, {
                                                horizontal: true,
                                                className: contentStyles.azureSubscriptionPurchase,
                                                tokens: {
                                                    childrenGap: 5
                                                },
                                                verticalAlign: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(FontIcon, {
                                                        iconName: "Info"
                                                    }),
                                                    /*#__PURE__*/ _jsx(AzureSubscriptionPurchase, {
                                                        hidden: isOneTimePaymentOffer(entityId),
                                                        offerId: entityId
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props, context){
        var _this_props_checkout_activeCustomer;
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "wizardStartTime", void 0), _define_property(this, "userPaymentInstruments", void 0), _define_property(this, "instrument", void 0), /** This is used as a flag to understand that steps *CAN* be set,
   * if this is false, then we can't determine if user is a new customer or not */ _define_property(this, "hasUpdatedStepsPostLoading", false), /** Used to only request product once.
   * This reset on every creation of the component,
   * however, it is compared to the redux state and that updates in between renders */ _define_property(this, "hasAlreadyRequestedProduct", false), _define_property(this, "paymentStepStartedTime", null), _define_property(this, "setPlaceOrderLogic", (placeOrderLogic)=>{
            this.setState({
                placeOrderLogic
            });
        }), _define_property(this, "setPi", (paymentInstrument)=>{
            this.userPaymentInstruments = paymentInstrument;
        }), _define_property(this, "activateStep", (selectedIdx)=>{
            const newSteps = this.state.steps.map((step, i)=>_object_spread_props(_object_spread({}, step), {
                    stepStatus: selectedIdx === i ? StepperNodeStatus.Active : i < selectedIdx ? StepperNodeStatus.Completed : StepperNodeStatus.NotCompleted,
                    displayName: this.getLocalizedDisplayName(step),
                    ariaLabel: this.getLocalizedDisplayName(step),
                    color: selectedIdx === this.state.steps.length - 1 ? StepperColors.Completed : StepperColors.Active
                }));
            this.setState({
                steps: newSteps
            });
        }), _define_property(this, "updateStepStatus", (selectedIndex, stepStatus)=>{
            const color = stepStatus === StepperNodeStatus.Failed ? StepperColors.Error : StepperColors.Active;
            const newSteps = this.state.steps.map((step, i)=>_object_spread_props(_object_spread({}, step), {
                    color: selectedIndex === i ? color : step.color,
                    stepStatus: selectedIndex === i ? stepStatus : step.stepStatus
                }));
            this.setState({
                steps: newSteps
            });
        }), _define_property(this, "disableNextButton", (shouldDisable)=>{
            if (this.state.nextButtonDisabled !== shouldDisable) this.setState({
                nextButtonDisabled: shouldDisable
            });
        }), _define_property(this, "disableBackButton", (shouldDisable)=>{
            if (this.state.backButtonDisabled !== shouldDisable) this.setState({
                backButtonDisabled: shouldDisable
            });
        }), _define_property(this, "resetCheckout", ()=>{
            this.props.setActiveStep(0);
            const newSteps = this.state.steps.map((step, i)=>_object_spread_props(_object_spread({}, step), {
                    stepStatus: i === 0 ? StepperNodeStatus.Active : StepperNodeStatus.NotCompleted
                }));
            this.setState({
                steps: newSteps
            });
        }), _define_property(this, "getLocalizedDisplayName", (step)=>{
            const { app: { entityId } } = this.props;
            const isOneTimePayment = isOneTimePaymentOffer(entityId);
            switch(step.id){
                case StepId.SelectBillingCountry:
                    return this.context.loc('Checkout_Step_Billing_Country', 'Billing country');
                case StepId.SelectPlan:
                    return this.context.loc('Checkout_Step_Plan', 'Plan');
                case StepId.SelectTerm:
                    return this.context.loc('Checkout_Step_PriceAndBilling', 'Price + billing');
                case StepId.Payment:
                    return this.context.loc('Checkout_Step_Payment', 'Payment');
                case StepId.ConfigureNow:
                    return isOneTimePayment ? this.context.loc('Checkout_Step_Complete_Purchase_OneTimePaymentTeams', 'Activate purchase') : this.context.loc('Checkout_Step_Complete_Purchase', 'Complete purchase');
                case StepId.TeamsVirtualStep:
                    return this.context.loc('Checkout_Step_Complete_Purchase', 'Complete purchase');
            }
        }), _define_property(this, "moveNextPage", ()=>{
            var // Scroll to top
            _getWindow;
            const { checkoutId, setActiveStep, currentStep } = this.props;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.scrollTo(0, 0);
            // Move to next step in wizard
            const targetIndex = Math.min(this.state.steps.length - 1, currentStep + 1);
            setActiveStep(targetIndex);
            this.activateStep(targetIndex);
            const payload = {
                page: location.href,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.NextCheckoutStep,
                details: `Total time in step: '${convertStepIdToName(this.state.steps[`${currentStep}`].id)}' is: ${performance.now() - this.wizardStartTime}. CheckoutId: ${checkoutId}`
            };
            this.log(payload);
        }), _define_property(this, "handleBackClick", ()=>{
            var _getWindow;
            const { checkoutId, setActiveStep, currentStep } = this.props;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.scrollTo(0, 0);
            const targetIndex = currentStep - 1 <= 0 ? 0 : currentStep - 1;
            setActiveStep(targetIndex);
            this.setState({
                backButtonDisabled: currentStep === 0,
                nextButtonDisabled: false
            });
            this.activateStep(targetIndex);
            const payload = {
                page: location.href,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.NextCheckoutStep,
                details: `Clicked back button on step: ${convertStepIdToName(this.state.steps[`${currentStep}`].id)}. CheckoutId: ${checkoutId}`
            };
            this.log(payload);
        }), _define_property(this, "getActiveStepComponent", ()=>{
            const activeStep = this.state.steps[this.props.currentStep];
            if (activeStep.stepStatus !== StepperNodeStatus.Active && activeStep.stepStatus !== StepperNodeStatus.Failed) {
                this.activateStep(this.props.currentStep);
            }
            const componentMap = {
                [StepId.SelectBillingCountry]: {
                    wizardProps: this.props,
                    disableBackButton: this.disableBackButton,
                    disableNextButton: this.disableNextButton,
                    updateStepStatus: this.updateStepStatus
                },
                [StepId.SelectPlan]: {
                    wizardProps: this.props,
                    disableBackButton: this.disableBackButton,
                    disableNextButton: this.disableNextButton
                },
                [StepId.SelectTerm]: {
                    wizardProps: this.props,
                    disableBackButton: this.disableBackButton,
                    disableNextButton: this.disableNextButton
                },
                [StepId.Payment]: {
                    wizardProps: this.props,
                    disableBackButton: this.disableBackButton,
                    disableNextButton: this.disableNextButton,
                    updateStepStatus: this.updateStepStatus,
                    setPi: this.setPi
                },
                [StepId.ConfigureNow]: {
                    wizardProps: this.props,
                    disableBackButton: this.disableBackButton,
                    disableNextButton: this.disableNextButton,
                    paymentInstruments: this.userPaymentInstruments
                }
            };
            const componentProps = componentMap[activeStep.id];
            return activeStep.componentToRender(componentProps);
        }), _define_property(this, "fetchProductIfNeeded", ()=>{
            const { app: { entityId }, checkout: { items }, users: { accessToken }, currentStep, fetchProduct, billingCountry } = this.props;
            const { steps } = this.state;
            const stepId = steps[`${currentStep}`].id;
            if (stepId === StepId.SelectPlan) {
                var _items_, _product_plans;
                const product = items === null || items === void 0 ? void 0 : (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.product;
                const shouldFetchProduct = !(product === null || product === void 0 ? void 0 : (_product_plans = product.plans) === null || _product_plans === void 0 ? void 0 : _product_plans.length) || // Indicates product is undefined
                entityId !== (product === null || product === void 0 ? void 0 : product.legacyId); // indicates the product (app) user is trying to purchase was changes
                if (shouldFetchProduct && !this.hasAlreadyRequestedProduct) {
                    fetchProduct(entityId, billingCountry);
                    this.hasAlreadyRequestedProduct = true;
                }
            }
        }), _define_property(this, "handlePlanSelected", ()=>{
            var _checkout_items;
            const { users: { roleDefinitions } = {}, adminFlow, isBagOffer, isProfessionalService, checkout, checkoutId, location: location1 } = this.props;
            const userType = getUserType(roleDefinitions);
            const cartItem = ((_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0]) || {};
            const { title: planTitle = '', bigId = '', entityId = '', skuId = '', appTitle = '' } = cartItem;
            this.log({
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.PlanSelected,
                page: location1.pathname,
                details: JSON.stringify({
                    bigId,
                    entityId,
                    skuId,
                    appTitle,
                    planTitle,
                    userType,
                    adminFlow,
                    isBagOffer,
                    isProfessionalService,
                    checkoutId
                })
            });
            this.moveNextPage();
        }), _define_property(this, "handleTermSelected", ()=>{
            var _checkout_items;
            const { users, config: { locale }, checkout, checkoutId, location: location1 } = this.props;
            const item = (_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0];
            const { bigId, skuId, termId, termDuration, recurringBilling, quantity, id: planId, product } = item;
            const { app: { entityId }, isBagOffer, isProfessionalService } = this.props;
            const isOneTimePayment = isOneTimePaymentOffer(entityId);
            const { cartItem } = getAppContainerProps({
                product,
                planId,
                termId,
                termDuration,
                users,
                locale,
                bigId,
                skuId,
                quantity,
                recurringBilling,
                isBagOffer,
                isOneTimePayment,
                isProfessionalService
            });
            const details = JSON.stringify(_object_spread_props(_object_spread({}, cartItem), {
                checkoutId
            }));
            this.log({
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.TermSelected,
                page: location1.pathname,
                details
            });
            this.moveNextPage();
            this.paymentStepStartedTime = Date.now();
        }), _define_property(this, "getNextButtonLogic", (stepId)=>{
            const { app } = this.props;
            const StepToNextButtonLogic = {
                [StepId.SelectBillingCountry]: this.handleBillingRegionChosen,
                [StepId.SelectPlan]: this.handlePlanSelected,
                [StepId.SelectTerm]: this.handleTermSelected,
                [StepId.Payment]: this.state.placeOrderLogic,
                [StepId.ConfigureNow]: isBagTransactable(app) ? this.onAssignLicensesButtonClick : this.onConfigureNowButtonClick
            };
            return StepToNextButtonLogic[`${stepId}`];
        }), _define_property(this, "getNextButtonDisplayText", (stepId)=>{
            const { app, app: { entityId } } = this.props;
            const isOneTimePayment = isOneTimePaymentOffer(entityId);
            const StepToNextDisplayTextLogic = {
                [StepId.Payment]: this.context.loc('Checkout_PlaceOrderButton', 'Place order'),
                [StepId.ConfigureNow]: isOneTimePayment ? this.context.loc('Checkout_OrderConfirmation_ButtonConfigureSaaSAccount_OneTimePaymentTeams', 'Activate your purchase') : isBagTransactable(app) ? this.context.loc('Checkout_OrderConfirmation_ButtonAssignLicensesBag', 'Assign licenses') : this.context.loc('Checkout_OrderConfirmation_ButtonConfigureSaaSAccount', 'Configure SaaS account')
            };
            var _StepToNextDisplayTextLogic_;
            return (_StepToNextDisplayTextLogic_ = StepToNextDisplayTextLogic[`${stepId}`]) !== null && _StepToNextDisplayTextLogic_ !== void 0 ? _StepToNextDisplayTextLogic_ : this.context.loc('Checkout_NextButton', 'Next');
        }), _define_property(this, "shouldDisableNextButton", (stepId)=>{
            var _product_plans;
            const { app, checkout: { items }, users: { tenantsDetails: { details: { tenantId } } } } = this.props;
            const { nextButtonDisabled } = this.state;
            const item = items[0];
            const { product } = item;
            const shouldFetchProduct = !(product === null || product === void 0 ? void 0 : (_product_plans = product.plans) === null || _product_plans === void 0 ? void 0 : _product_plans.length) || app.entityId !== (product === null || product === void 0 ? void 0 : product.legacyId);
            const isMSuser = tenantId === Constants.MSTenantId;
            const StepToDisableNextButtonLogic = {
                [StepId.SelectPlan]: shouldFetchProduct,
                [StepId.SelectTerm]: isMSuser || nextButtonDisabled,
                [StepId.ConfigureNow]: false
            };
            var _StepToDisableNextButtonLogic_;
            return (_StepToDisableNextButtonLogic_ = StepToDisableNextButtonLogic[`${stepId}`]) !== null && _StepToDisableNextButtonLogic_ !== void 0 ? _StepToDisableNextButtonLogic_ : nextButtonDisabled;
        }), _define_property(this, "shouldDisableBackButton", (stepId)=>{
            const { backButtonDisabled } = this.state;
            const StepToDisableBackButton = {
                [StepId.SelectPlan]: true,
                [StepId.SelectTerm]: false,
                [StepId.ConfigureNow]: true
            };
            var _StepToDisableBackButton_;
            return (_StepToDisableBackButton_ = StepToDisableBackButton[`${stepId}`]) !== null && _StepToDisableBackButton_ !== void 0 ? _StepToDisableBackButton_ : backButtonDisabled;
        }), _define_property(this, "getSelectPlanHeader", ()=>{
            var _this_props_checkout;
            return /*#__PURE__*/ _jsx(Stack, {
                horizontal: true,
                horizontalAlign: "space-between",
                tokens: {
                    childrenGap: 5
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            className: "new-checkout-step-header ms-fontWeight-semibold",
                            children: this.context.loc('Checkout_SelectPlanComponentTitle', 'Select a plan')
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mb-32 mt-20",
                            children: [
                                ((_this_props_checkout = this.props.checkout) === null || _this_props_checkout === void 0 ? void 0 : _this_props_checkout.items.length) > 0 && this.props.checkout.items[0].appImageUri && /*#__PURE__*/ _jsx("img", {
                                    className: "img-icon",
                                    src: this.props.checkout.items[0].appImageUri
                                }),
                                " ",
                                this.props.app && this.props.app.title && /*#__PURE__*/ _jsx(Text, {
                                    className: "plan-panel-title-header",
                                    children: this.props.app.title
                                })
                            ]
                        })
                    ]
                })
            });
        }), _define_property(this, "hideBackButton", (stepId)=>{
            const { app: { entityId } } = this.props;
            const isOneTimePayment = isOneTimePaymentOffer(entityId);
            if (isOneTimePayment) {
                const { steps } = this.state;
                return steps[0].id === stepId; // If we are in the first step, then disable the back button.
            }
            if (stepId === StepId.SelectBillingCountry && this.state.steps.length === NEW_CUSTOMER_CHECKOUT_LENGTH) return true;
            if (stepId === StepId.SelectPlan && this.state.steps.length === OLD_CUSTOMER_CHECKOUT_LENGTH) return true;
            return false;
        }), _define_property(this, "log", ({ action, actionModifier, details, page })=>{
            const { app: { entityId: appName = '' } = {} } = this.props;
            this.instrument.probe('logTelemetryInfo', {
                appName,
                action,
                actionModifier,
                details,
                page
            });
            logger.info(details, {
                appName,
                action,
                actionModifier,
                page
            });
        }), _define_property(this, "onConfigureNowButtonClick", ()=>{
            var _this_props_checkout_items, _this_props_checkout_publisherToken, _this_props_checkout_publisherToken1, _getNpsModule;
            const { users: { roleDefinitions } = {}, adminFlow, isBagOffer, isProfessionalService, checkoutId } = this.props;
            const userType = getUserType(roleDefinitions);
            const cartItem = (_this_props_checkout_items = this.props.checkout.items) === null || _this_props_checkout_items === void 0 ? void 0 : _this_props_checkout_items[0];
            const { bigId = '', entityId = '', skuId = '', appTitle = '', title: planTitle = '' } = cartItem || {};
            this.log({
                page: this.props.location.pathname,
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.ConfigureNowButton,
                details: JSON.stringify({
                    offerURI: (_this_props_checkout_publisherToken = this.props.checkout.publisherToken) === null || _this_props_checkout_publisherToken === void 0 ? void 0 : _this_props_checkout_publisherToken.publisherOfferBaseUri,
                    cartItem: {
                        bigId,
                        entityId,
                        skuId,
                        appTitle,
                        planTitle
                    },
                    userType,
                    adminFlow,
                    isBagOffer,
                    isProfessionalService,
                    checkoutId
                })
            });
            if ((_this_props_checkout_publisherToken1 = this.props.checkout.publisherToken) === null || _this_props_checkout_publisherToken1 === void 0 ? void 0 : _this_props_checkout_publisherToken1.offerUriWithToken) {
                var // eslint-disable-next-line security/detect-non-literal-fs-filename
                _getWindow;
                (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.open(this.props.checkout.publisherToken.offerUriWithToken, '_blank');
            }
            (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.ctaClicked(false);
        }), _define_property(this, "handleBillingRegionChosen", ()=>{
            const { config, checkout, setBillingCountry, createCustomer, users, billingCountry, checkoutId, location: location1 } = this.props;
            if (isNewCustomer(checkout)) {
                confirmBillingCountry({
                    config,
                    setBillingCountry,
                    createCustomer
                });
            }
            this.moveNextPage();
            this.log({
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.BillingCountrySelected,
                details: JSON.stringify({
                    selected: billingCountry,
                    userType: getUserType(users === null || users === void 0 ? void 0 : users.roleDefinitions),
                    checkoutId
                }),
                page: location1 === null || location1 === void 0 ? void 0 : location1.pathname
            });
        }), _define_property(this, "onAssignLicensesButtonClick", ()=>{
            var _checkout_items, _checkout_publisherToken;
            const { checkoutId, location: location1, checkout, config } = this.props;
            this.log({
                page: location1.pathname,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.AssignLicensesButton,
                details: JSON.stringify({
                    currentView: config.currentView,
                    cartItem: (_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0],
                    offerURI: (_checkout_publisherToken = checkout.publisherToken) === null || _checkout_publisherToken === void 0 ? void 0 : _checkout_publisherToken.publisherOfferBaseUri,
                    checkoutId
                })
            });
            getWindow().open(Constants.AdminCenterLicensesLink, '_blank');
        });
        this.wizardStartTime = performance.now();
        this.instrument = SpzaInstrumentService.getProvider();
        const { app: { entityId } } = this.props;
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        if (isOneTimePayment && !CheckoutSteps.includes(TeamsCheckoutSteps)) {
            CheckoutSteps.push(TeamsCheckoutSteps);
        }
        this.state = {
            steps: isNewCustomer(this.props.checkout) || this.props.featureFlags.newCustomerFlow === 'true' ? CheckoutSteps : CheckoutSteps.slice(1, CheckoutSteps.length),
            nextButtonDisabled: false,
            backButtonDisabled: false,
            wizardStarted: false,
            placeOrderLogic: null,
            isCountryConfirmed: !!((_this_props_checkout_activeCustomer = this.props.checkout.activeCustomer) === null || _this_props_checkout_activeCustomer === void 0 ? void 0 : _this_props_checkout_activeCustomer.address)
        };
    }
}
Wizard.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
